import {financeAPI} from 'axios';

export const state = {
    cashiertemplates: [],
    isCashierTemplatesLoading: false
}

export const mutations = {
    SET_CASHIER_TEMPLATES(state, cashiertemplates) {
        state.cashiertemplates = cashiertemplates;
    },
    SET_CASHIER_TEMPLATES_LOADING(state, isCashierTemplatesLoading) {
        state.isCashierTemplatesLoading = isCashierTemplatesLoading;
    }
}

export const actions = {
    getCashierTemplatesByCampus(context, {campusId}) {
        return financeAPI.get(`CashierTemplate/Campus/${campusId}`)
    },
    createCashierTemplate(context, data)
    {
        return financeAPI.post('CashierTemplate/Create', data)
    },
    getSingleCashierTemplate(context, id)
    {
        return financeAPI.get(`CashierTemplate/${id}`)
    },
    updateCashierTemplate(context, data)
    {
        return financeAPI.put(`CashierTemplate/${data.id}`, data)
    },
    deleteCashierTemplate(context, id)
    {
        return financeAPI.delete(`CashierTemplate/${id}`)
    },

    /** Cashier Template Items */
    getTemplateItems(context, cashierTemplateId)
    {
        return financeAPI.get(`CashierTemplateItem/CashierTemplate/${cashierTemplateId}`)
    },
    createTemplateItem(context, data)
    {
        return financeAPI.post('CashierTemplateItem/Add', data)
    },
    getSingleCashierTemplateItem(context, id)
    {
       return financeAPI.get(`CashierTemplateItem/${id}`)
    },
    updateCashierTemplateItem(context, data)
    {
        return financeAPI.put(`CashierTemplateItem/Update/${data.id}`, data)
    },
    deleteCashierTemplateItem(context, id)
    {
        return financeAPI.delete(`CashierTemplateItem/${id}`)
    }
}